<template>
  <div class="info-container common">
    <div class="info-row" v-if="info.infoType == '1'">
      <div class="info-label">农机编号：</div>
      <div class="info-value">{{ info.machineName }}</div>
    </div>
    <div class="info-row" v-if="info.infoType == '1'">
      <div class="info-label">农机类型：</div>
      <div class="info-value">{{ info.machineType }}</div>
    </div>
    <!-- 托管单 -->
    <div class="info-row" v-if="info.infoType == '2'">
      <div class="info-label">农户：</div>
      <div class="info-value">{{ info.farmerName }}</div>
    </div>
    <div class="info-row" v-if="info.infoType == '3'">
      <div class="info-label">自营土地：</div>
      <div class="info-value"></div>
    </div>
    <div class="info-row" v-if="info.infoType == '2'">
      <div class="info-label">联系电话：</div>
      <div class="info-value">{{ info.farmerPhone }}</div>
    </div>
    <div class="info-row" v-if="info.infoType == '1'">
      <div class="info-label">机手：</div>
      <div class="info-value">{{ info.userName || "无" }}</div>
    </div>
    <div class="info-row" v-if="info.infoType == '1'">
      <div class="info-label">状态：</div>
      <div class="info-value">{{ info.status == "1" ? "作业中" : "空闲" }}</div>
    </div>
    <div class="info-row" v-if="info.infoType == '1' || info.infoType == '2'">
      <div class="info-label">位置：</div>
      <div class="info-value">{{ info.areaName }}</div>
    </div>
    <div class="info-row" v-if="info.infoType == '2'">
      <div class="info-label">土地面积：</div>
      <div class="info-value">{{ info.landArea }}亩</div>
    </div>
    <div class="info-row" v-if="info.infoType == '3'">
      <div class="info-label">土地面积：</div>
      <div class="info-value">{{ info.flowAreaMu }}亩</div>
    </div>
    <div class="info-row" v-if="info.infoType == '2'">
      <div class="info-label">作物类型：</div>
      <div class="info-value">{{ info.cropCode }}</div>
    </div>
    <div class="info-row center-y" v-if="info.infoType == '2'">
      <div class="info-label">作业环节：</div>
      <div v-if="info.orderType == '2'" class="info-value">
        {{ info.orderContent }}
      </div>
      <div v-else class="info-value">
        <el-select
          size="mini"
          style="width: 100px"
          v-model="machinistOrderInfo.cropName"
          filterable
          placeholder="请选择"
          @change="changeOrderCropContent"
        >
          <el-option
            v-for="item in operScopeList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
    </div>
    <!-- 作物类型区域开始 -->

    <!-- <div v-if="info.infoType == '3' && info.orderType">
      作物类型：{{ info.orderType }}
    </div> -->

    <div class="info-row center-y" v-if="info.infoType == '3'">
      <div class="info-label">作物类型：</div>
      <div class="info-value">
        <el-select
          size="mini"
          style="width: 100px"
          :no-data-text="loadText"
          v-model="machinistOrderInfo.cropType"
          filterable
          placeholder="请选择"
          @change="changeCropType"
        >
          <el-option
            v-for="item in cropTypeList"
            :key="item.label"
            :label="item.label"
            :value="item"
          ></el-option>
        </el-select>
      </div>
    </div>
    <!-- 作物类型区域结束 -->

    <!-- 作业环节区域开始 -->
    <div class="info-row center-y" v-if="info.infoType == '3'">
      <div class="info-label">作业环节：</div>
      <div class="info-value">
        <el-select
          size="mini"
          style="width: 100px"
          v-model="machinistOrderInfo.cropName"
          filterable
          placeholder="请选择"
          @change="changeCropContent"
        >
          <el-option
            v-for="item in operScopeList"
            :key="item.label"
            :label="item.label"
            :value="item"
          ></el-option>
        </el-select>
      </div>
    </div>
    <!-- 作业环节区域结束 -->
    <div class="info-row" v-if="info.infoType == '2'">
      <div class="info-label">机手：</div>
      <div class="info-value">{{ machinistOrderInfo.machinistName || "无" }}</div>
    </div>
    <div class="info-row" v-if="info.infoType == '3'">
      <div class="info-label">机手：</div>
      <div class="info-value">
        {{ machinistOrderInfo.machinistName || "无" }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getCompanyCrop, //作物类型选择
  getCropContent, //作业环节选择
} from "@/api/add";
import {
  selectCropTypeMachinist, //获取
  selectOrderCropTypeMachinist,
} from "@/api/njdd";
export default {
  data() {
    return {
      cropTypeList: [], //作物类型选择库
      operScopeList: [], //作业环节选择器
      machinistOrderInfo: {
        cropType: "", //作物类型
        cropName: "", //作业环节名称
        xmbsm: "", //订单编码(自营土地)
        orderId: "", //订单编码（托管土地）
        machinistName: "", //机手姓名(旧)
        machinistId: "", //机手id（旧）
      }, //调用作业环节和机手信息的入参信息表
      addInfo: {}, //作业环节绑定机手的入参信息表
      loadText: "无数据",
    };
  },
  props: ["info"],
  computed: {
    ...mapGetters(["topSelectAreacode", "topSelectAreaname", "identityObj"]),
  },
  created() {
    // console.log(JSON.parse(JSON.stringify(this.info)) , '查看获取的info类型')
    if (this.info.infoType == "3") {
      this.machinistOrderInfo.xmbsm = this.info.xmbsm;
      this.machinistOrderInfo.cropType = this.info.orderType || "";

      // console.log('infoff', this.machinistOrderInfo)

      // 此处需优化 应该改为 有orderType作物类型时直接调用作物环节列表拉取
      // 没有orderType作物类型时先调用作物类型列表接口
      if (!this.info.orderType) {
        //没有进行分配，将加载作物类型和环节托管列表进行加载
        this.getCompanyCrop();
      } else {
        //回显作业类型
        this.machinistOrderInfo.cropType = this.info.orderType; // 作物类型
        this.machinistOrderInfo.cropName = this.info.cropName; //作业环节
        this.machinistOrderInfo.machinistName = this.info.machinistName; //分配的机手
        this.getCompanyCrop();
        // this.changeCropContent()
      }

      console.log(this.machinistOrderInfo, "查看this.machinistOrderInfo");
      localStorage.setItem(
        "machinistOrderInfo",
        JSON.stringify(this.machinistOrderInfo)
      );
    } else if (this.info.infoType == "2") {
      this.machinistOrderInfo = {
        cropType: "", //作物类型
        cropName: "", //作业环节名称
        xmbsm: "", //订单编码(自营土地)
        orderId: this.info.id, //订单编码（托管土地）
        machinistName: this.info.machinistName, //机手姓名(旧)
        machinistId: this.info.machinistId, //机手id（旧）
        tglx: this.info.orderType, //托管类型
      };
      this.operScopeList = this.info.orderContent.split(",");
      // this.machinistOrderInfo.cropName = this.operScopeList[0] || ""; //作业环节默认第一个
      this.machinistOrderInfo.cropName = this.info.selOrderType; //当前选中的作业环节
      this.machinistOrderInfo.cropType = this.info.cropCode; // 作物类型
      this.machinistOrderInfo.machinistName = this.info.machinistName; //分配的机手
      this.machinistOrderInfo.operateId = this.info.operateId; //分配表中每条记录的id
      console.log("-----------------", this.info);

      localStorage.setItem(
        "machinistOrderInfo",
        JSON.stringify(this.machinistOrderInfo)
      );
    }
  },
  methods: {
    //获取作物类型
    async getCompanyCrop() {
      let res = await getCompanyCrop({
        areaCode: this.info.xzqbh.substring(0, 6),
      });
      if (res.code == 0) {
        if (res.data.length > 0) {
          res.data.forEach((item) => {
            item.label = item.categoryName;
            item.value = item.id;
          });
          this.cropTypeList = res.data;
        } else {
          this.cropTypeList = [];
        }
      } else {
        this.cropTypeList = [];
      }
      if (this.machinistOrderInfo.cropType) {
        //如果订单表中已存入作物类型 则不用选择器触发作业环节接口 直接匹配id传入
        this.cropTypeList.forEach((item) => {
          if (item.categoryName == this.machinistOrderInfo.cropType) {
            this.getCropContent(item.id);
          }
        });
      }
    },
    //获取作业环节列表
    async getCropContent(id) {
      let res = await getCropContent({id});
      console.log("getCropContent回调", res);
      if (res.code == 0) {
        if (res.data.length > 0) {
          res.data.forEach((item) => {
            item.label = item.categoryName;
            item.value = item.id;
          });
          this.operScopeList = res.data;
        } else {
          this.operScopeList = [];
        }
      } else {
        this.operScopeList = [];
      }
      console.log("查看作业环节列表", this.operScopeList);
    },
    //改变作物类型
    changeCropType(e) {
      console.log("改变作物类型", e);
      this.machinistOrderInfo.cropType = e.categoryName;
      // this.machinistOrderInfo.orderTypeId=e.ca
      console.log("11", this.machinistOrderInfo);
      //获取对应的作业环节列表
      this.getCropContent(e.id);
      // 作物类型改变作业环节清空
      this.machinistOrderInfo.cropName = null; //作业环节
    },
    //改变作业环节
    changeCropContent(e) {
      console.log("改变作业环节", e);
      this.machinistOrderInfo.cropName = e.categoryName;
      console.log("this.machinistOrderInfo", this.machinistOrderInfo);
      this.selectCropTypeMachinist();
    },
    //获取机手和作业环节的对应关系
    async selectCropTypeMachinist() {
      let res = await selectCropTypeMachinist({
        cropName: this.machinistOrderInfo.cropName,
        xmbsm: this.machinistOrderInfo.xmbsm,
      });
      // console.log("查看机手和作业环节对应关系回调", res,);
      // console.log('machinistId', res.data, res.data.machinistId, res.data.machinistName, res.data.operateId)
      this.machinistOrderInfo.machinistName = res.data.machinistName || "";
      this.machinistOrderInfo.machinistId = res.data.machinistId || "";
      this.machinistOrderInfo.operateId = res.data.operateId || "";
      // 刷新数据
      let temp = "";
      temp = this.machinistOrderInfo;
      this.machinistOrderInfo = "";
      this.machinistOrderInfo = temp;
      console.log("复制后的this.machinistOrderInfo", this.machinistOrderInfo);
      localStorage.setItem(
        "machinistOrderInfo",
        JSON.stringify(this.machinistOrderInfo)
      );
      this.$emit("windowChange", {
        msg: "点击资源资产",
        data: this.machinistOrderInfo,
      });
    },
    //改变全程托管单的作业环节
    changeOrderCropContent(e) {
      console.log("改变全程托管单的作业环节", e);
      this.machinistOrderInfo.cropName = e;
      this.selectOrderCropTypeMachinist();
    },
    //获取全程托管单中机手和作业环节的对应关系
    async selectOrderCropTypeMachinist() {
      console.log("111111----------", this.machinistOrderInfo);
      let res = await selectOrderCropTypeMachinist({
        orderId: this.machinistOrderInfo.orderId,
        cropName: this.machinistOrderInfo.cropName,
      });
      console.log("res-----------", res);
      this.machinistOrderInfo.machinistName = res.data?.machinistName ?? "";
      this.machinistOrderInfo.machinistId = res.data?.machinistId ?? "";
      this.machinistOrderInfo.operateId = res.data?.operateId ?? "";
      // 刷新数据
      let temp = "";
      temp = this.machinistOrderInfo;
      this.machinistOrderInfo = "";
      this.machinistOrderInfo = temp;

      localStorage.setItem(
        "machinistOrderInfo",
        JSON.stringify(this.machinistOrderInfo)
      );
      this.$emit("windowChange", {
        msg: "点击托管单",
        data: this.machinistOrderInfo,
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/JStyle";
.info-container .info-row .info-label {
  width: 70px;
}
</style>
